import { Card, CardContent, Typography, Box, Chip } from '@mui/material'

export default function FillrateCard({
  title,
  subtitle,
  value,
  icon,
  isdisabled = false,
  status = null,
  lines,
  amount
}) {
  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: 3,
        border: '3px solid #E4E4E4',
        backgroundColor: isdisabled ? '#F9FAFB' : '#FFFFFF',
        height: 166,
        width: '100%',
        containerType: 'inline-size'
      }}
    >
      <CardContent
        className={isdisabled ? 'fillrate-card-disabled' : ''}
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          p: 2.5,
          '@container (max-width: 330px)': {
            p: 1.5
          }
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box display="flex" alignItems="center" gap={1.5}>
            {icon}
            <Typography
              sx={{
                fontSize: 15,
                fontWeight: 700,
                letterSpacing: 0.3,

                '@container (max-width: 330px)': {
                  fontSize: 13
                }
              }}
            >
              {title}
            </Typography>
          </Box>

          {status && (
            <Chip
              label={status}
              size="small"
              className="fillrate-card-chip-active"
              sx={{
                height: 22,
                fontSize: 11,
                backgroundColor: '#E5E7EB',
                fontWeight: 500
              }}
            />
          )}
        </Box>
        <Typography
          sx={{
            color: '#8E909B',
            fontSize: 13,
            mt: 1,

            '@container (max-width: 330px)': {
              fontSize: 12
            }
          }}
        >
          {subtitle}
        </Typography>
        <Typography
          sx={{
            fontSize: 44,
            fontWeight: 800,
            color: '#4672A3',
            lineHeight: 1.1,
            mt: 1,
            '@container (max-width: 330px)': {
              fontSize: 32
            }
          }}
        >
          {value}
        </Typography>

        <Box
          sx={{
            mt: 'auto',
            display: 'flex',
            gap: 3,
            '@container (max-width: 330px)': {
              gap: 1.5
            }
          }}
        >
          <Typography fontSize={14}>
            Líneas: <strong>{lines ?? '—'}</strong>
          </Typography>

          <Typography fontSize={14}>
            Monto: <strong>{amount ?? '$0.00'}</strong>
          </Typography>
        </Box>
      </CardContent>
    </Card>
  )
}
